import type { ErrorInfo, ErrorMessageIf } from '@/utils/globalError/entities/valueObjects/types'
import { ERROR_CODES } from './errorCode'

const defaultErrorObject: ErrorInfo = {
  message: '',
  needsSupport: false,
  note: '',
  title: ''
}

/** エラーメッセージ */
export const ERROR_MESSAGES: ErrorMessageIf = {
  /** 共通メッセージ */
  [ERROR_CODES.ROUTE_ACCESS_ERROR]: {
    ...defaultErrorObject,
    message: '操作する権限がありません。(原因: 権限がなく画面遷移に失敗)'
  },
  [ERROR_CODES.API_EXECUTION_FAILED]: {
    ...defaultErrorObject,
    message: 'API の実行に失敗しました。(原因: アクセス回線障害など)',
    title: 'エラー'
  },

  /** ログイン画面 */
  [ERROR_CODES.USER_INFO_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: 'ユーザー情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.NO_ACCESSIBLE_SCREENS]: {
    ...defaultErrorObject,
    message: 'アクセス権限がありません。<br>システム管理者へ連絡してください。'
  },
  [ERROR_CODES.GOVERNMENT_SETTING_FAILED]: {
    ...defaultErrorObject,
    message: '自治体情報の取得に失敗しました。',
    title: 'エラー'
  },

  /** アノテーション選択画面 */
  [ERROR_CODES.USER_INFO_FETCH_FAILED_ANNOTATION]: {
    ...defaultErrorObject,
    message: 'ユーザー情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.ANNOTATION_INFO_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: 'アノテーション情報の取得に失敗しました。',
    title: 'エラー'
  },

  /** 被害状況可視化画面 */
  [ERROR_CODES.USER_INFO_FETCH_FAILED_VISUALIZATION]: {
    ...defaultErrorObject,
    message: 'ユーザー情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.DISASTER_INFO_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: '災害情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.GOVERNMENT_SETTING_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: '自治体情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.MAP_INFO_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: '地図情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.BUILDING_INFO_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: '建物情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.INSPECTION_INFO_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: '調査情報の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.CSV_CREATION_FAILED]: {
    ...defaultErrorObject,
    message: 'CSV ファイルの作成に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.IMAGE_DOWNLOAD_FAILED]: {
    ...defaultErrorObject,
    message: '画像ファイルの取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.EMERGENCY_INSPECTION_INFO_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: '応急危険度判定結果の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.AI_BUILDING_INFO_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: 'AI倒壊判定結果の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.FETCH_DONUT_DATA_FAILED]: {
    ...defaultErrorObject,
    message: '円グラフデータの取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.GEO_SERVER_RUN_FAILED]: {
    ...defaultErrorObject,
    message: 'ジオサーバの起動に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.GEO_SERVER_VERIFY_FAILED]: {
    ...defaultErrorObject,
    message: 'ジオサーバの起動確認に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.GET_BUILDING_DETAILS_FAILED]: {
    ...defaultErrorObject,
    message: '建造物詳細の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.REGISTER_ICON_IMAGE_FAILED]: {
    ...defaultErrorObject,
    message: 'アイコン画像の登録に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.GET_AERIAL_AREAS_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: '空撮範囲の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.ANNOTATION_IMAGE_FETCH_FAILED]: {
    ...defaultErrorObject,
    message: 'アノテーション画像の取得に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.CLASSIFICATION_ANNOTATION_RUN_FAILED]: {
    ...defaultErrorObject,
    message: '分類アルゴリズム（アノテーション）の起動に失敗しました。',
    title: 'エラー'
  },
  [ERROR_CODES.DISASTER_INFO_NOT_SET]: {
    ...defaultErrorObject,
    message:
      '災害情報が未設定です。<br>被害調査統合システムにてシステム管理者が災害情報の登録を行ってください。',
    title: 'エラー'
  }
} as const
